import { FC } from "react";
import cn from "classnames";
import { useLocation } from "react-router";
import { useAppSelector } from "src/hooks/redux";
import { selectCurrentUserState } from "src/redux/currentUser/selector";
import { PATHNAMES } from "src/constants/routes";
import { Roles } from "src/@types/users";
import { Logo } from "../Logo";
import { MessagesButton } from "../Header/MessagesButton";
import { MobMenu } from "../MobMenu";
import { MOB_MENU_ITEMS } from "../MobMenu/constants";

interface Props {
  isShown?: boolean;
}

export const MobHeader: FC<Props> = ({ isShown = true }) => {
  const location = useLocation();

  const { isAuthorized, currentUser } = useAppSelector(selectCurrentUserState);

  const isHomePage = location.pathname === PATHNAMES.HOME;

  const isOwner = currentUser?.host?.role === Roles.OWNER;

  const filteredMenuItems = MOB_MENU_ITEMS.filter(
    (item) => !(isOwner && item.slug === "favourites")
  );

  if (!isShown) return null;

  return (
    <header className="gl:hidden">
      <div className="fixed bottom-0 w-full bg-white-pink rounded-t-20 py-2 px-2 xs:px-5 shadow-light-top z-20">
        <MobMenu items={filteredMenuItems} />
      </div>

      {!isHomePage && (
        <div
          className={cn(
            "container bg-white-pink fixed top-0 flex justify-center py-5 z-20 shadow-light-bottom",
            {
              "!justify-between": isAuthorized,
            }
          )}
        >
          <Logo isColored={!isHomePage} />

          {isAuthorized && (
            <div
              className={cn(
                "flex justify-center items-center gap-5",
                isHomePage ? "fill-svg-white-base" : "fill-svg-purple-base"
              )}
            >
              {/* <MessagesButton iconClassName="!w-6 !h-6" /> */}
              {/* notification button */}
            </div>
          )}
        </div>
      )}
    </header>
  );
};
